import CustomLayout from "./wrapPageElement"
import { init as initApm } from '@elastic/apm-rum'

export const wrapPageElement = CustomLayout

export const onClientEntry = () => {
   initApm({
        serviceName: 'docs-builder',
        serverUrl: process.env.GATSBY_ELASTIC_URL,
        environment: window.origin
    });
}

let routeChangeTransaction = null;

export const onPreRouteUpdate = ({ location, prevLocation }) => {
    document.body.classList.remove('loaded');
    routeChangeTransaction = window.elasticApm && window.elasticApm.startTransaction(location.pathname, "client-route-change");
}

export const onRouteUpdate = ({ location, prevLocation }) => {
    if (window.location.hash?.startsWith('#toc-')) {
        window.location.replace(location.hash.replace('#toc-', '#'));
    }

    document.body.classList.add('loaded');

    if (routeChangeTransaction) {
        routeChangeTransaction.end();
        routeChangeTransaction = null;
    }

    if (prevLocation && prevLocation.pathname !== location.pathname) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: `docsSpaPageView`,
            spaPageViewLocation: location.href,
            spaPageViewPath: location.pathname
        });
    }
}

export const disableCorePrefetching = () => true;